import MatchMakingService from './services/matchMakingService'

function App() {
  return <MatchMakingService />
}

export default App
